import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subject, Subscription } from 'rxjs';

import { IPagedResponse } from '../../shared/interfaces';

@Component({
    selector: 'aza-rws-pager',
    templateUrl: 'pager.component.html',
    styleUrls: ['pager.component.css'],
    standalone: false
})
export class PagerComponent implements OnInit, OnDestroy {
    rangeText = '0 / 0';
    lastPagedResponse: IPagedResponse;
    canMoveToNext = false;
    canMoveToPrev = false;
    subscriptions: Subscription[] = [];

    @Input() pageSize: number;
    @Input() pagedResponseSubject: Subject<IPagedResponse>;
    @Output() offsetChanged = new EventEmitter<number>();

    ngOnInit(): void {
        if (this.pagedResponseSubject) {
            this.subscriptions.push(this.pagedResponseSubject.subscribe({
                next: pagedResponse => this.processPagedResponse(pagedResponse)
            }));
        }
    }

    processPagedResponse(pagedResponse: IPagedResponse): void {
        this.lastPagedResponse = pagedResponse;
        const startPosition = pagedResponse.offset + 1;
        let endPosition = startPosition + pagedResponse.limit - 1;
        if (endPosition > pagedResponse.object_count) {
            endPosition = pagedResponse.object_count;
        }
        this.canMoveToNext = endPosition < pagedResponse.object_count;
        this.canMoveToPrev = startPosition > 1;
        this.rangeText = `${startPosition} - ${endPosition} / ${pagedResponse.object_count}`;
    }

    goPrev(): void {
        if (!this.lastPagedResponse) {
            return;
        }
        let newOffset = this.lastPagedResponse.offset - this.pageSize;
        if (newOffset < 0) {
            newOffset = 0;
        }
        this.offsetChanged.next(newOffset);
    }

    goNext(): void {
        if (!this.lastPagedResponse) {
            return;
        }
        const newOffset = this.lastPagedResponse.offset + this.pageSize;
        this.offsetChanged.next(newOffset);
    }

    ngOnDestroy(): void {
        for (const sub of this.subscriptions) {
            sub.unsubscribe();
        }
    }
}
